import axios from 'axios';
import { API_BASE_URL, API_TIMEOUT, API_VERSION } from '../../constants/api.constants';
import { storage } from '../../utils/common/storage';
import { decryptData } from '../../../utils/decryption';
// import { authService } from '../auth.service';
const api = axios.create({
  baseURL: API_BASE_URL + API_VERSION,
  timeout: API_TIMEOUT,
  headers: {
    'x-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});
// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = storage.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      response.data = decryptData(response.data);
    }
    return response;
  },
  async (error) => {
    // const originalRequest = error.config;
    if (error.response) {
      const { status, data } = error.response;
      if ([500, 400].includes(status)) {
        return Promise.reject(data?.message);
      } else if (status === 422) {
        const mesg = data?.errors?.length ? data?.errors?.[0] : data?.message
        return Promise.reject(mesg);
      } else if (status === 403 || status == 401) {
        // Handle token expiration
        // if (!originalRequest._retry) {
        //   originalRequest._retry = true;
        //   try {
        //     const newToken = await authService.refreshToken();
        //     storage.setToken(newToken);
        //     originalRequest.headers.Authorization = `Bearer ${newToken}`;
        //     return api(originalRequest);
        //   } catch (refreshError) {
        //     storage.clearAll();
        //     window.location.href = '/login';
        //     return Promise.reject(refreshError);
        //   }
        // }
        storage.clearAll();
        window.location.href = '/login';
        return Promise.reject(data?.message);
      } else if ([404, 405].includes(status)) {
        return Promise.reject("Some Error Occured, please try later.");
      } else {
        return Promise.reject([data?.message]);
      }
    } else {
      return Promise.reject("Something went wrong, please try later.");
    }
  }
);

export default api;